<template>
  <div>
    <!-- 状态栏 -->
    <el-row>
      <el-form
        :inline="true"
        :model="filters"
        @submit.native.prevent
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
      >
        <el-form-item label="客户姓名">
          <el-input
            v-model.trim="filters.merchantName"
            clearable
            placeholder="请输入客户姓名"
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item label="工单编号">
          <el-input
            v-model="filters.orderNo"
            clearable
            placeholder="请输入工单编号"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            plain
            @click.native.prevent="handleFindPage"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </el-row>

    <!--表格内容栏-->
    <el-table
      :data="tableData"
      :height="'400'"
      style="width: 100%"
      :row-style="tableRowStyle"
      :header-cell-style="tableHeaderColor"
    >
      <el-table-column
        prop="createdTime"
        label="下单时间"
        :show-overflow-tooltip="true"
        min-width="120"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="serverName"
        label="服务对象"
        :show-overflow-tooltip="true"
        min-width="80"
        align="center"
      ></el-table-column>

      <el-table-column
        prop="groupName"
        label="商户名称"
        :show-overflow-tooltip="true"
        min-width="120"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="creator"
        label="服务人员"
        :show-overflow-tooltip="true"
        min-width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="peopleStarLevel"
        label="服务评价"
        :show-overflow-tooltip="true"
        min-width="200"
        align="center"
      >
        <template slot-scope="scope">
          <el-rate
            v-model="scope.row.score"
            disabled
            disabled-void-color="#cccccc"
          >
          </el-rate>
        </template>
      </el-table-column>
      <el-table-column
        prop="evaluate"
        label="评价内容"
        :show-overflow-tooltip="true"
        min-width="140"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="otherContents"
        label="评价图片"
        :show-overflow-tooltip="true"
        min-width="140"
        align="center"
      >
      <template slot-scope="scope">
        <div class="img_box" v-if="scope.row.evaluatePicture!=null && scope.row.evaluatePicture.length >0">
              <el-image class="img" style="width:38px;height:38px;" :key="scope.row.evaluatePicture" :preview-src-list="[scope.row.evaluatePicture]" :src="scope.row.evaluatePicture"/>
        </div>
      </template>
    </el-table-column>
      <!-- <el-table-column label="操作" min-width="120" align="center">
        <template slot-scope="scope">
          <el-button
            icon="el-icon-document"
            type="primary"
            size="mini"
            @click="look(scope.$index, scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>

    <!-- 分页 -->
    <el-pagination
      background
      layout="total,prev, pager, next,jumper"
      :total="total"
      align="center"
      class="fenye"
      @current-change="changePage"
      :current-page="currentPage"
    ></el-pagination>

    <!--评论详情-->
    <el-dialog
      title="查看"
      width="50%"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="dataForm"
        label-width="120px"
        ref="dataForm"
        label-position="right"
      >
        <el-row type="flex" justify="center">
          <el-col :span="20">
            <el-row>
              <el-col :span="12">
                <el-form-item label="工单来源:">
                  <span class="tableSpan">{{ dataForm.orderSource }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="工单编号:">
                  <span class="tableSpan">{{ dataForm.orderNo }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="客户姓名:">
                  <span class="tableSpan">{{ dataForm.oldmanName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系方式:">
                  <span class="tableSpan">{{ dataForm.userPhone }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="联系地址:">
                  <span class="tableSpan">{{ dataForm.serviceAddress }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="订单金额:">
                  <span class="tableSpan">{{ dataForm.total }}元</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="服务名称:" prop="inventoryWarningQuantity">
                  <span class="tableSpan">{{ dataForm.merchandiseName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="服务人员:" prop="userNameGet">
                  <span class="tableSpan">{{ dataForm.userNameGet }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="服务人员评价:" prop="peopleStarLevel">
                  <el-rate
                    style="margin-top: 10px"
                    v-model="dataForm.peopleStarLevel"
                    disabled
                    disabled-void-color="#cccccc"
                  >
                  </el-rate>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="服务项目评价:" prop="starLevel">
                  <el-rate
                    style="margin-top: 10px"
                    v-model="dataForm.starLevel"
                    disabled
                    disabled-void-color="#cccccc"
                  >
                  </el-rate>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="服务评价:" prop="contents">
                  <span class="tableSpan">{{ dataForm.contents }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="追评:" prop="otherContents">
                  <span class="tableSpan">{{ dataForm.otherContents }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="下单时间:" prop="createdTime">
                  <span class="tableSpan">{{ dataForm.createdTime }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click.native="dialogVisible = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import KtButton from "@/components/KtButton";
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  components: {
    KtButton,
  },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value !== this.codeDataForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      pageNum: 1,
      pageSize: 10,
      currentPage: 1,
      total: 0,
      tableData: [],
      size: "medium",
      filters: {
        merchantName: "",
        orderNo: "",
      },
      dataForm: {},
      dialogVisible: false,
      businessId: "",
    };
  },
  methods: {
    /* 
      键盘事件 按下键盘回车 查询
    */
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        //查询时重置页码参数，每次从第一页开始，否则会有bug, 因为pageNum不在第一页时，重新查询空的之后数据会显示不是第一页的数据，但是页码显示是第一页
        this.pageNum = 1;
        this.currentPage = 1;
        this.findPage();
      }
    },

    deleteMerchantName() {
      this.filters.merchantName = "";
    },

    /* 
      点击查询按钮查询
    */
    handleFindPage() {
      this.pageNum = 1;
      this.currentPage = 1;
      this.findPage();
    },
    //查询分页列表的数据
    findPage() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        groupId: sessionStorage.getItem("groupId"),
        orderNo: this.filters.orderNo,
      };
      this.$postJson("omc/serviceOrder/evaluatePage", param).then((res) => {
        res.result.list.map((item) => {
          item.createdTime = item.createdTime.split(".")[0];
          item.orderSource == 1
            ? (item.orderSource = "app下单")
            : item.orderSource == 2
            ? (item.orderSource = "平台下单")
            : item.orderSource == 3
            ? (item.orderSource = "政府下单")
            : (item.orderSource = "");
          return item;
        });
        this.tableData = res.result.list;
        this.total = Number(res.result.total);
      });
    },

    //翻页
    changePage(val) {
      this.pageNum = val;
      this.currentPage = val;
      this.findPage();
    },

    //查看
    look(index, row) {
      this.dialogVisible = true;
      this.dataForm = row;
    },

    /* 
      修改table tr行的背景色
    */
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #efefef;";
      }
    },
  },
  mounted() {
    this.findPage();
  },
};
</script>
<style lang="scss" scoped>
.tableSpan {
  display: block;
  height: 40px;
  padding-top: 10px;
  box-sizing: border-box;
}
.fenye {
  margin: 0px;
  padding: 30px 0;
  background: #fff;
}
//  ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
</style>